module.exports = __webpack_public_path__ + "user-search.9c86fc91eb4fb9a75023.svg";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/icon/user-search.svg
// module id = ../../../../../src/img/icon/user-search.svg
// module chunks = styles